const SATELLITE_SOURCE_ID = 'maplibre-map-satellite-source';
const SATELLITE_LAYER_ID = 'maplibre-map-satellite-layer';
const SATELLITE_LAYER_BEFORE_ID = 'Airport labels';
const LABEL_LAYER_KEYWORDS = ['label', 'place', 'poi', 'road-name'];
const LABEL_LAYER_STYLE_CACHE_KEY = '__maplibreLayerControlLabelPaint';

const SATELLITE_LABEL_PAINT_OVERRIDES = {
  'text-color': '#ffffff',
  'text-halo-color': '#111827',
  'text-halo-width': 2,
  'text-halo-blur': 0.75,
  'icon-halo-color': '#111827',
  'icon-halo-width': 1.5,
  'icon-halo-blur': 0.5,
};

function getSatelliteLabelLayers(map) {
  return map.getStyle().layers?.filter(layer => (
    layer.type === 'symbol'
    && LABEL_LAYER_KEYWORDS.some(keyword => layer.id.includes(keyword))
  )) ?? [];
}

function getLabelPaintCache(map) {
  if (!map[LABEL_LAYER_STYLE_CACHE_KEY]) {
    map[LABEL_LAYER_STYLE_CACHE_KEY] = new Map();
  }

  return map[LABEL_LAYER_STYLE_CACHE_KEY];
}

function applySatelliteLabelStyles(map) {
  const labelLayers = getSatelliteLabelLayers(map);
  const paintCache = getLabelPaintCache(map);

  labelLayers.forEach((layer) => {
    if (!paintCache.has(layer.id)) {
      const originalPaint = Object.keys(SATELLITE_LABEL_PAINT_OVERRIDES).reduce((paintProperties, property) => {
        paintProperties[property] = map.getPaintProperty(layer.id, property);
        return paintProperties;
      }, {});

      paintCache.set(layer.id, originalPaint);
    }

    Object.entries(SATELLITE_LABEL_PAINT_OVERRIDES).forEach(([property, value]) => {
      map.setPaintProperty(layer.id, property, value);
    });
  });
}

function restoreLabelStyles(map) {
  const paintCache = getLabelPaintCache(map);

  paintCache.forEach((paintProperties, layerId) => {
    if (!map.getLayer(layerId)) {
      return;
    }

    Object.entries(paintProperties).forEach(([property, value]) => {
      map.setPaintProperty(layerId, property, value);
    });
  });
}

function ensureSatelliteLayer(map) {
  if (!map.isStyleLoaded()) {
    return;
  }

  if (!map.getSource(SATELLITE_SOURCE_ID)) {
    map.addSource(SATELLITE_SOURCE_ID, {
      type: 'raster',
      tiles: [
        `https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=${import.meta.env.VITE_MAPTILER_KEY}`,
      ],
      tileSize: 512,
    });
  }

  if (!map.getLayer(SATELLITE_LAYER_ID)) {
    map.addLayer({
      id: SATELLITE_LAYER_ID,
      type: 'raster',
      source: SATELLITE_SOURCE_ID,
      layout: {
        visibility: 'none',
      },
    }, SATELLITE_LAYER_BEFORE_ID);
  }
}

function setSatelliteLayerVisibility(map, visibility) {
  ensureSatelliteLayer(map);

  if (!map.getLayer(SATELLITE_LAYER_ID)) {
    return;
  }

  map.setLayoutProperty(SATELLITE_LAYER_ID, 'visibility', visibility);
}

function showSatelliteLayer(map) {
  setSatelliteLayerVisibility(map, 'visible');
  applySatelliteLabelStyles(map);
}

function hideSatelliteLayer(map) {
  setSatelliteLayerVisibility(map, 'none');
  restoreLabelStyles(map);
}

export {
  ensureSatelliteLayer,
  hideSatelliteLayer,
  showSatelliteLayer,
};
